import type { ApiConfig } from '../../types'

export const depositHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 100,
  order: 'desc',
  // Classic (v2) の上限に合わせる。Unified Account (v3) は 30 日までしか受け付けないが、
  // fetchApiData 側で 30 日窓へ分割するため、ここは広い方を維持する。
  range: 90 * 24 * 60 * 60 * 1000, // 90 days in milliseconds
  requiresRange: true,
  type: 'deposit-history',
} as const satisfies ApiConfig
